namespace TabAurous.HR {
    export interface EmploymentTypeRow {
        EmploymentTypeId?: number;
        Code?: string;
        Name?: string;
    }

    export namespace EmploymentTypeRow {
        export const idProperty = 'EmploymentTypeId';
        export const nameProperty = 'Code';
        export const localTextPrefix = 'HR.EmploymentType';
        export const deletePermission = 'Administration:General';
        export const insertPermission = 'Administration:General';
        export const readPermission = 'Administration:General';
        export const updatePermission = 'Administration:General';

        export declare const enum Fields {
            EmploymentTypeId = "EmploymentTypeId",
            Code = "Code",
            Name = "Name"
        }
    }
}
